import React from "react";
import { connect } from "react-redux";
import WebHeading from "../../components/WebHeading";
import * as edmiActions from "../../redux/actions/edmi";
import * as boxActions from "../../redux/actions/box";
import {
  Button as RNButton,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  View,
} from "react-native";
import { errorColors, RepositStyles } from "../../utils/styles";
import goTo from "../../utils/goTo";
import { bindActionCreators } from "redux";
import MenuButton from "../../components/MenuButton";
import Icon from "react-native-vector-icons/FontAwesome";
import storage from "../../utils/storage";

const mapStateToProps = (state) => ({
  serial: state.edmi.serial,
  rp115sPermitted: state.box.rp115sPermitted,
});

const mapDispatchToProps = (dispatch) => ({
  edmiActions: bindActionCreators(edmiActions, dispatch),
  boxActions: bindActionCreators(boxActions, dispatch),
});

const styles = StyleSheet.create({
  wrapper: { backgroundColor: "white", flex: 1 },
  textInput: {
    fontSize: 16,
    height: Platform.OS === "android" ? 40 : 25,
    textAlign: "center",
  },
  textInputWrapper: {
    alignItems: "center",
  },
  textInputContainer: {
    width: 300,
    borderBottomWidth: Platform.OS === "android" ? 0 : 1,
    borderBottomColor: "#D2D2D2",
  },
});

class EdmiSerial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "New Setup",
  };

  handleSubmit = () => {
    if (this.props.serial) {
      this.setState({ error: null });
      goTo(this.props.navigation, "SiteDetails");
    } else {
      this.setState({
        error: "Please enter the EDMI serial number.",
      });
    }
  };

  setEdmiSerial = (serial) => {
    this.props.edmiActions.setEdmiSerial(serial);
  };

  clearEdmiAndNavigate = (rp115sPermitted) => {
    const { edmiActions, navigation } = this.props;

    if (rp115sPermitted === false) {
      this.setState({
        error:
          "This particular Reposit box cannot be used with Reposit meters. " +
          "An EDMI serial number is required.",
      });
    } else {
      edmiActions.clearEdmiSerial();
      this.setState({ error: null });
      goTo(navigation, "SiteDetails");
    }
  };

  handleNoEdmi = () => {
    const { rp115sPermitted } = this.props;

    if (rp115sPermitted === null) {
      storage
        .load({ key: "rp115sPermitted" })
        .then((ret) => {
          this.props.boxActions.insertRp115sPermitted(ret);
          this.clearEdmiAndNavigate(ret);
        })
        .catch((err) => {
          this.clearEdmiAndNavigate(null);
        });
    } else {
      this.clearEdmiAndNavigate(rp115sPermitted);
    }
  };

  render() {
    const error = this.state.error;
    return (
      <View style={styles.wrapper}>
        <WebHeading title="New Setup" />
        <View style={{ flex: 1, alignItems: "center" }}>
          <View style={{ flex: 1, maxWidth: 800, maxHeight: 600 }}>
            <View style={{ flex: 3, justifyContent: "space-around" }}>
              <Text style={RepositStyles.headerText}>EDMI Meter</Text>
              <Text
                style={{ ...RepositStyles.paragraphText, alignSelf: "center" }}
              >
                If the site uses an EDMI meter, please enter its serial number.
              </Text>
              <View style={styles.textInputWrapper}>
                <View style={styles.textInputContainer}>
                  <TextInput
                    value={this.props.serial}
                    onChangeText={this.setEdmiSerial}
                    autoCorrect={false}
                    style={styles.textInput}
                    keyboardType="numeric"
                    onSubmitEditing={this.handleSubmit}
                    placeholder="EDMI Serial Number"
                  />
                </View>
                {error && (
                  <Text
                    style={{
                      ...RepositStyles.paragraphText,
                      color: errorColors.orange,
                    }}
                  >
                    <Icon name="exclamation-circle" /> {error}
                  </Text>
                )}
              </View>
              <View />
              <View>
                <Text
                  style={{
                    ...RepositStyles.paragraphText,
                    textAlign: "center",
                  }}
                >
                  No EDMI meter?
                </Text>
                <View style={{ alignSelf: "center" }}>
                  <RNButton
                    onPress={this.handleNoEdmi}
                    title=" Configure without EDMI "
                    color="#4698CB"
                  />
                </View>
              </View>
            </View>

            <View
              style={{
                flex: 2,
                justifyContent: "flex-end",
                alignItems: "center",
                marginBottom: -40,
              }}
            >
              <RNButton
                onPress={this.handleSubmit}
                title=" Next "
                color="#4698CB"
              ></RNButton>
              <Text style={RepositStyles.nextSub}>Site Details</Text>
            </View>
            <View style={{ flex: 1 }} />
          </View>
        </View>
      </View>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EdmiSerial);



// WEBPACK FOOTER //
// ./src/containers/kit/EdmiSerial.js